import {
  setDoc,
  getDoc,
  doc,
  collection,
  serverTimestamp,
  where,
  query,
  getDocs,
} from "firebase/firestore";
import { db } from "./firebase";

export async function updateAlbumCollection(owner, album) {
  const userCollectionRef = doc(db, "users", owner.uid);
  return await setDoc(
    userCollectionRef,
    {
      album,
      lastUpdate: serverTimestamp(),
    },
    { merge: true }
  );
}

export async function getAlbumCollection(user) {
  const userCollectionRef = doc(db, "users", user.uid);
  return await getDoc(userCollectionRef)
    .then((result) => {
      if (result.exists()) {
        const album = result.data();
        if (album.album) {
          return album.album;
        }
      } else {
        return false;
      }
    })
    .catch((error) => {
      return false;
    });
}

export async function getMyAlbums(email) {
  const albumCollectionRef = collection(db, "users");
  const searchResults = [];
  const q = query(
    albumCollectionRef,
    where("album.autorizados", "array-contains", {
      email: email,
      editar: true,
    })
  );
  const q2 = query(
    albumCollectionRef,
    where("album.autorizados", "array-contains", {
      email: email,
      editar: false,
    })
  );
  let querySnapshot = await getDocs(q);
  let querySnapshot2 = await getDocs(q2);

  querySnapshot.forEach((doc) => {
    searchResults.push(doc.data());
  });
  querySnapshot2.forEach((doc) => {
    searchResults.push(doc.data());
  });
  return searchResults;
}

export async function getAlbumById(id) {
  if (!id) {
    return;
  }
  const albumCollectionRef = collection(db, "users");
  const q = query(albumCollectionRef, where("album.albumID", "in", [id]));
  const querySnapshot = await getDocs(q);
  let album;
  querySnapshot.forEach((doc) => {
    album = doc.data().album;
  });
  return album;
}
